module.exports = __webpack_public_path__ + "static/media/pompy-A.eff74b0f.svg";